module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9OHhX"))).then(() => parcelRequire('9ywsj'));